import React from 'react';
import TableBody from './table_body.jsx';
import TableMenu from './table_menu.jsx';
import TableHeader from './table_header.jsx';
import TableFooter from './table_footer';
import styles from './table.module.scss'
import { Trans } from 'react-i18next';
    
export default class Table extends React.Component {

    constructor(props) {
        super(props);

        this.getFilteredItems = this.getFilteredItems.bind(this);
        this.getSortedItems = this.getSortedItems.bind(this);
    }

    getFilteredItems(modelFilter) {
        const filter = this.props.settings.itemsFilter;
        filter.modelFilter = modelFilter;
        filter.pagesFilter.currentPage = 1;
        this.props.settings.getItemsFunction(filter);
    }

    getSortedItems(sortFilter) {
        const filter = this.props.settings.itemsFilter;
        filter.sortFilter = sortFilter;
        filter.pagesFilter.currentPage = 1;
        this.props.settings.getItemsFunction(filter);
    }
        
    render() {
        let isEmpty = this.props.settings.items.length === 0;
        return (
            <div className={styles.soft_oil_table}>
                <TableMenu addItemFunction={this.props.settings.addItemFunction}
                    getFilteredItems={this.getFilteredItems}
                    itemsFilter={this.props.settings.itemsFilter}
                    getReportFunction={this.props.settings.getReportFunction}/>
                {isEmpty
                    ? <div style={{ display: "block", width: "100%", lineHeight: "35px", textAlign: "center" }}><Trans>Table.Empty</Trans>
                    </div>
                    :
                    <div style={{overflow: "auto"}}><table>
                        <TableHeader
                            columns={this.props.settings.columns}
                            isEditable={this.props.settings.isEditable}
                            itemsFilter={this.props.settings.itemsFilter}
                            getSortedItems={this.getSortedItems}/>
                          <TableBody
                              columns={this.props.settings.columns}
                              items={this.props.settings.items}
                              isEditable={this.props.settings.isEditable}
                              isEditableRows={this.props.settings.isEditableRows}
                              editItemFunction={this.props.settings.editItemFunction}/>
                    </table>
                    </div>}
                {!isEmpty &&
                    <TableFooter getItemsFunction={this.props.settings.getItemsFunction} itemsFilter={this.props.settings.itemsFilter}/>}
            </div>
        );
    }

}